var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "language-switcher" },
    [
      !_vm.isMobileApp || (_vm.isMobileApp && _vm.userAgent !== "ios")
        ? [
            _c("v-select", {
              staticClass: "select_lang",
              attrs: { items: _vm.availableLanguages, label: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.selectLocale(_vm.lang)
                },
                change: function($event) {
                  return _vm.selectLocale(_vm.$i18n.locale)
                }
              },
              model: {
                value: _vm.$i18n.locale,
                callback: function($$v) {
                  _vm.$set(_vm.$i18n, "locale", $$v)
                },
                expression: "$i18n.locale"
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobileApp && _vm.userAgent === "ios"
        ? [
            _c(
              "v-btn",
              {
                staticClass: "select_lang",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.selectLocaleIOS()
                  }
                }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      (_vm.appConfigDateFormats[
                        _vm.$i18n.locale.toLowerCase()
                      ] &&
                        _vm.appConfigDateFormats[_vm.$i18n.locale.toLowerCase()]
                          .switcherDisplayName) ||
                        _vm.lang
                    ) +
                    "\n      "
                ),
                _c("v-icon", [_vm._v("arrow_drop_down")])
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55622826", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55622826","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/LanguageSwitcher.vue
// module id = null
// module chunks = 